/******************************************************************************
 * Copyright 2023 TypeFox GmbH
 * This program and the accompanying materials are made available under the
 * terms of the MIT License, which is available in the project root.
 ******************************************************************************/
export * from './document-validator.js';
export * from './validation-registry.js';
//# sourceMappingURL=index.js.map